import type { GetProgressInput } from './dtos/models';
import type { Progress, ProgressItem } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProgressService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getByInput = (input: GetProgressInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Progress[]>({
      method: 'GET',
      url: '/api/app/progress',
      params: { supervisorIds: input.supervisorIds },
    },
    { apiName: this.apiName,...config });
  

  getItemsByInput = (input: GetProgressInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProgressItem[]>({
      method: 'GET',
      url: '/api/app/progress/items',
      params: { supervisorIds: input.supervisorIds },
    },
    { apiName: this.apiName,...config });
}